import { NodeModel } from "../_model/NodeModel";
import { DecorationEvaporativeCondenser } from "./decorationEvaporativeCondenser";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class EvaporativeCondenser extends NodeModel {
  constructor() {
    super("EvaporativeCondenser");

    this.type = new Types().EvaporativeCondenser;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 140;
    this.width = 130;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/condensadorEvaporativo.png");
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationEvaporativeCondenser();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new EvaporativeCondenser();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
			cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
    };
  }
}

export { EvaporativeCondenser };
